module.exports = __webpack_public_path__ + "img/services-who-we-are.0e6f3c9e.png";